import {
  getConfiguration,
  axiosInstance,
} from '@foxtrotplatform/platform-micro-site-core';
import { AxiosRequestConfig } from 'axios';

import {
  ApiResponse,
  StripeIntent,
  RazorpayOrderCreated,
  PriceBreakdown,
} from './types';

export const createRazorPayOrder = async (uuid: string) => {
  const config = await getConfiguration();
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/payment/gateway/signup/razorpay/order`,
    method: 'post',
    data: { uuid, version: 2 },
  };
  const response: ApiResponse<RazorpayOrderCreated> = await axiosInstance(
    request
  );
  return response.data;
};

export const createStripeIntent = async (uuid: string) => {
  const config = await getConfiguration();
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/payment/gateway/signup/stripe/intent`,
    method: 'post',
    data: { uuid, version: 2 },
  };
  const response: ApiResponse<StripeIntent> = await axiosInstance(request);
  return response.data;
};

export const getPriceBreakdownForTier = async (uuid: string) => {
  const config = await getConfiguration();
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/payment/gateway/signup/priceBreakdown`,
    method: 'post',
    data: { uuid },
  };
  const response: ApiResponse<PriceBreakdown[]> = await axiosInstance(request);
  return response.data;
};
